import { render, staticRenderFns } from "./IndexDoReconChange.vue?vue&type=template&id=b8a0a572&scoped=true"
import script from "./IndexDoReconChange.vue?vue&type=script&lang=js"
export * from "./IndexDoReconChange.vue?vue&type=script&lang=js"
import style0 from "./IndexDoReconChange.vue?vue&type=style&index=0&id=b8a0a572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a0a572",
  null
  
)

export default component.exports